import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { get } from 'lodash';

import Header from 'components/Header';
import ApplicationId from 'components/ApplicationId';
import imgComplete from 'assets/images/complete.svg';

const Complete = ({ params, checkinData, navigate }) => {
  const [searchParams] = useSearchParams();
  const workflowType = get(params, 'workflowType') || 'ida';

  useEffect(() => {
    if (get(checkinData, ['data']) === undefined) {
      navigate(`/${workflowType}/welcome/?key=${searchParams.get('key')}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} inHeadline />
      <div className="content">
        <img src={imgComplete} alt="" />
        <h1>Thank you! If we need any further information we will reach out.</h1>
        <p>
          If you have questions please call
          {' '}
          {get(checkinData, 'data.data.channelCode') === 'dtc-crypto' ? '(844) 721-6961' : '(800) 994-6177'}
        </p>
      </div>
    </div>
  );
};

Complete.propTypes = {
  params: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Complete);
